import { filter, first, last } from "lodash";
import type { IDaySchedule } from "App/Modules/Models";
import { DayType } from "App/Modules/Models";
import type { Duration, Moment } from "moment-timezone";
import { duration, utc } from "moment-timezone";

export class TimeFilters {
    public static durationToLocalTimeString(durationInput: Duration): string {
        return utc(durationInput.asMilliseconds()).format("LT");
    }

    public static durationToLocalDate(durationInput: Duration): Date {
        const timeString = utc(durationInput.asMilliseconds()).format("HH:mm");
        const utcMoment = utc(timeString, "HH:mm").local();
        const date = utcMoment.subtract(utcMoment.utcOffset(), "minutes").toDate();
        return date;
    }
}

export function FromNow() {
    return (date: Date) => {
        return utc(date).fromNow();
    };
}

export function IsInFuture() {
    return (items: any[], dateFieldName: string) => {
        return filter(items, (item: any) => {
            if (item[dateFieldName]) {
                return (item[dateFieldName] as Moment).isAfter(new Date());
            }
            return item;
        });
    };
}

export function LocalizeHoursNumber() {
    return (hours: number) => {
        const time = utc(duration(hours, "h").asMilliseconds());
        const timeString = time.format("LT");
        const isMeridiem = timeString.includes("AM") || timeString.includes("PM");

        return isMeridiem ? time.format("h A") : timeString;
    };
}

export function OrderDaysByLocale() {
    return (daySchedules: IDaySchedule[]) => {
        if (daySchedules) {
            const irMondayNumber = first(daySchedules).dayType;

            if (
                utc().weekday(irMondayNumber).isSame(utc().isoWeekday(irMondayNumber)) &&
                irMondayNumber === DayType.Monday
            ) {
                return [last(daySchedules), ...daySchedules.slice(0, 6)];
            }

            return daySchedules;
        }
        return undefined;
    };
}

export function TranslateIsoWeekday() {
    return (weekdayNumber: number): string => {
        if (weekdayNumber <= 7) {
            return utc().isoWeekday(weekdayNumber).format("dddd");
        }
        return undefined;
    };
}
